function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM4.08333 6.41669C3.76117 6.41669 3.5 6.67785 3.5 7.00002C3.5 7.32219 3.76117 7.58335 4.08333 7.58335H9.91667C10.2388 7.58335 10.5 7.32219 10.5 7.00002C10.5 6.67785 10.2388 6.41669 9.91667 6.41669H4.08333Z",
  fill: "#BBC1C7"
});
const SvgDeleteFile = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-file.2f82bc09.svg";
export { ForwardRef as ReactComponent };